import React from 'react'
import { Skeleton } from '@/components/layout/Skeleton/Skeleton'

const ForecastCardCarouselSkeleton: React.FC = () => {
  return (
    <Skeleton className="flex flex-col xl:flex-row w-full min-h-[405px] xl:min-h-[250px] rounded-lg pl-2 xl:pl-6 pr-2 xl:pr-4 pt-4 pb-2 xl:pb-4 bg-skyblue">
      {/* Left section */}
      <div className="flex flex-col xl:flex-row flex-1 basis-2/3">
        <h3 className="pl-2 xl:pl-0 text-white font-bold text-xl xl:text-4xl leading-tight">
          Wetterdaten werden geladen...
        </h3>
      </div>
      {/* Spacer */}
      <div className="xl:hidden flex-1" />
      {/* Daily forecast boxes */}
      <div className="basis-1/3 bg-white rounded pt-4 pb-5 xl:py-10 px-2 mb-0">
        <div className="sm:flex flex-row justify-evenly h-full items-center hidden">
          {[...Array(4)].map((_, idx) => (
            <div
              className="flex flex-col items-center h-full justify-between gap-y-2 xl:gap-y-4"
              key={idx}
            >
              <Skeleton className="w-14 h-3" />
              <Skeleton className="w-14 h-12" />
              <Skeleton className="w-14 h-6" />
            </div>
          ))}
        </div>
        <div className="flex flex-row justify-evenly h-full items-center sm:hidden">
          {[...Array(3)].map((_, idx) => (
            <div
              className="flex flex-col items-center h-full justify-between gap-y-2"
              key={idx}
            >
              <Skeleton className="w-14 h-3" />
              <Skeleton className="w-14 h-12" />
              <Skeleton className="w-14 h-6" />
            </div>
          ))}
        </div>
      </div>
    </Skeleton>
  )
}

export default ForecastCardCarouselSkeleton
